// src/components/CheckoutSteps.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User, MapPin, CreditCard, FileCheck, CheckCircle2 } from 'lucide-react';

const CheckoutSteps = ({ step1, step2, step3, step4 }) => {
  const navigate = useNavigate();

  const steps = [
    { 
      id: 1, 
      label: 'ورود', 
      icon: User, 
      active: step1, 
      path: '/login?redirect=/shipping' 
    },
    { 
      id: 2, 
      label: 'آدرس', 
      icon: MapPin, 
      active: step2, 
      path: '/shipping' 
    },
    { 
      id: 3, 
      label: 'پرداخت', 
      icon: CreditCard, 
      active: step3, 
      path: '/payment' 
    },
    { 
      id: 4, 
      label: 'ثبت سفارش', 
      icon: FileCheck, 
      active: step4, 
      path: '/placeorder' 
    },
  ];

  const handleClick = (step) => {
    if (step.active) {
      navigate(step.path);
    }
  };

  // محاسبه درصد پیشرفت
  const activeCount = steps.filter(s => s.active).length;
  const progressPercent = ((activeCount - 1) / (steps.length - 1)) * 100;

  return (
    // ✅ حذف dir="rtl" برای تغییر جهت به LTR
    <div className="w-full py-6 px-4 md:px-8">
      <div className="relative flex items-center justify-between max-w-3xl mx-auto">
        
        {/* ===== خط پس‌زمینه ===== */}
        <div className="absolute top-5 left-0 right-0 h-0.5 bg-gray-200 -z-10" />

        {/* ===== خط پیشرفت (از چپ به راست) ===== */}
        <div 
          // ✅ تغییر left-0 و bg-gradient-to-r
          className="absolute top-5 left-0 h-0.5 bg-gradient-to-r from-emerald-500 to-emerald-400 -z-10 transition-all duration-700 ease-out"
          style={{ width: `${Math.max(0, progressPercent)}%` }}
        />

        {/* ===== مراحل ===== */}
        {steps.map((step, index) => {
          const isActive = step.active;
          const isCompleted = isActive && index < steps.length - 1 && steps[index + 1]?.active;

          return (
            <div 
              key={step.id} 
              className="flex flex-col items-center group"
              onClick={() => handleClick(step)}
            >
              {/* دایره مرحله */}
              <div 
                className={`
                  relative w-11 h-11 rounded-full flex items-center justify-center 
                  border-2 transition-all duration-300 cursor-pointer
                  ${isActive 
                    ? 'border-emerald-500 bg-emerald-500 text-white shadow-lg shadow-emerald-200/50' 
                    : 'border-gray-300 bg-white text-gray-400 hover:border-gray-400'
                  }
                  ${isActive ? 'hover:scale-110' : 'hover:scale-105'}
                  ${!isActive && 'cursor-not-allowed opacity-60'}
                `}
              >
                {isCompleted ? (
                  <CheckCircle2 className="w-5 h-5" />
                ) : (
                  <step.icon className="w-5 h-5" />
                )}

                {/* شماره مرحله (هوشمند) */}
                {!isActive && !isCompleted && (
                  <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-gray-200 text-gray-500 text-[10px] font-bold flex items-center justify-center">
                    {step.id}
                  </span>
                )}
              </div>

              {/* برچسب مرحله */}
              <span 
                className={`
                  mt-2.5 text-xs font-medium transition-colors duration-300
                  ${isActive 
                    ? 'text-emerald-700 font-bold' 
                    : 'text-gray-400'
                  }
                `}
              >
                {step.label}
              </span>

              {/* نشانگر فعال (نقطه زیر) */}
              {isActive && (
                <span className="mt-1 w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
              )}
            </div>
          );
        })}
      </div>

      {/* ===== متن راهنما (اختیاری) ===== */}
      <div className="text-center mt-4 text-[11px] text-gray-400">
        {steps.filter(s => s.active).length === 1 && 'برای ادامه، مراحل را تکمیل کنید'}
        {steps.filter(s => s.active).length === 2 && 'نصف راه را طی کرده‌اید'}
        {steps.filter(s => s.active).length === 3 && 'تقریباً تمام شد!'}
        {steps.filter(s => s.active).length === 4 && '✅ سفارش شما آماده ثبت است'}
      </div>
    </div>
  );
};

export default CheckoutSteps;